export const validation = {
  newPassword: 'Please enter new password',
  confirmPassword: 'Please enter confirm password',
  matchPassword: 'Password and confirm password do not match',
};
